import { Box, Flex, Text, useColorMode, useColorStyle } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import blockLock from '../../../assets/image/img-block.svg';
import { isInUIC } from '@Utils/common';
const PageNotFound = () => {
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  const FlexItem = (props: any) => (
    <Box verticalAlign="middle" fontSize="14px" {...props} />
  );
  return (
    <>
      <Flex pt="192px" px="4x">
        <FlexItem flex="auto">{}</FlexItem>
        <FlexItem flex="auto" textAlign="center" width="544px" height="294px">
          <img src={blockLock} />
          <Text
            color={colorStyle.color.primary}
            fontSize="16px"
            lineHeight="22px"
            mt={16}
          >
            {t('common.label.accessDenied')}
          </Text>
          <Text color={colorStyle.color.secondary} mt={8}>
            {!isInUIC()
              ? t('common.label.accessDeniedMessage')
              : t('common.label.accessV1ecsDeniedMessage')}
          </Text>
          <Text color={colorStyle.color.secondary}>
            {!isInUIC()
              ? t('common.label.accessDeniedMessageMore')
              : t('common.label.accessV1ecsDeniedMessageMore')}
          </Text>
        </FlexItem>
        <FlexItem flex="auto">{}</FlexItem>
      </Flex>
    </>
  );
};
export default PageNotFound;
